export const OCP_ANALYTICS = {
  // Tokens for specific actions (used as "name" in Matomo)
  TOKEN: {
    DASHBOARD_TEAM_SELECTED: 'Sidebar/Team_Selected',
    //TEAMS
    TEAMS_PROJECT_SELECTED: 'Sidebar/Project_Selected',
    TEAMS_CREATE_NEW_PROJECT: 'Create_New_Project',
    //PROJECTS
    PROJECTS_UPLOAD_MODEL: 'Upload_Model',
    PROJECTS_CREATE_NEW_TASK: 'Create_New_Task',
    PROJECTS_UPDATE_MODEL_UPDATE: 'Update',
    PROJECTS_UPDATE_MODEL_VIEW: 'View',
    PROJECTS_UPDATE_MODEL_UPLOAD: 'Upload',
    //MODELS
    MODELS_UPLOAD_MODEL_IFC: 'Upload_Model_IFC',
    MODELS_UPLOAD_MODEL_MODEL: 'Upload_Model_MODEL',
    MODELS_UPDATE_MODEL_UPLOAD: 'Upload_Model',
    MODELS_TABLE_VIEW_MODEL: 'Table/View_Model',
    MODELS_TABLE_ACTIONS_DELETE_MODEL: 'Table/Actions/Delete',
    MODELS_TABLE_ACTIONS_VIEW_MODEL: 'Table/Actions/View_Model',
    MODELS_TABLE_ACTIONS_OPEN_VIEWER: 'Open_3D_Viewer',
    MODELS_TABLE_ACTIONS_RENAME: 'Table/Actions/Rename',
    MODELS_TABLE_ACTIONS_DOWNLOAD: 'Table/Actions/Download',
    MODELS_TABLE_ACTIONS_COPY_LINK: 'Table/Actions/Copy_Link',
    MODELS_BULK_EDIT_ACTIONS_VIEW_SELECTED: 'Table/Bulk_Edit/View_Selected',
    //TASKS
    TASKS_CREATE_NEW_TASK: 'Create_New_Task',
    TASKS_ADD_SCENE: 'Create_Add_Scene',
    TASKS_DELETE_SCENE: 'Delete_Scene',
    TASKS_SCENE_PAGINATION_PREVIOUS: 'Scene_Pagination_Previous',
    TASKS_SCENE_PAGINATION_NEXT: 'Scene_Pagination_Next',
    TASKS_SCENE_PAGINATION_PAGE: 'Scene_Pagination_Page',
    TASKS_BULK_EDIT_ASSIGN_TO: 'Table/Bulk Edit/Assign_To',
    TASKS_BULK_EDIT_STATUS: 'Table/Bulk Edit/Status',
    TASKS_TABLE_STATUS: 'Table/Status',
    TASKS_TABLE_ASSIGNEE: 'Table/Assignee',
    TASKS_TABLE_PRIORITY: 'Table/Priority',
    TASKS_TABLE_ACTIONS_VIEW_DETAILS: 'Table/Actions/View_Details',
    TASKS_TABLE_ACTIONS_COPY_LINK: 'Table/Actions/Copy_Link',
    //TASK DETAILS
    TASK_DETAIL_STATUS: 'Status',
    TASK_DETAIL_ASSIGNEE: 'Assignee',
    TASK_DETAIL_PRIORITY: 'Priority',
    TASK_DETAIL_ADD_COMMENT: 'Add_Comment',
    TASK_DETAIL_DUE_DATE: 'Due_Date',
    TASK_DETAIL_TAGS: 'Tags',
    TASK_DETAIL_WATCHERS: 'Watchers',
    //MEMBERS
    MEMBERS_INVITE_MEMBER: 'Invite_Member',
    MEMBERS_TABLE_REMOVE_MEMBER: 'Table/Actions/Remove_Member',
    MEMBERS_TABLE_REVOKE_INVITATION: 'Table/Actions/Revoke_Invitation',
    MEMBERS_TABLE_RESEND_INVITE: 'Table/Actions/Resend_Invite',
    //SIDEBAR
    SIDEBAR_CREATE_NEW_TEAM: 'Sidebar/Create_New_Team',
    SIDEBAR_CREATE_NEW_PROJECT: 'Sidebar/Create_New_Project',
  },
  ACTION: {
    VISIT: 'Visit',
    CLICK: 'Click',
    CREATE: 'Create',
    SAVE: 'Save',
    DELETE: 'Delete',
    CANCEL: 'Cancel',
  },
} as const;

export type MatomoToken = (typeof OCP_ANALYTICS.TOKEN)[keyof typeof OCP_ANALYTICS.TOKEN];
export type MatomoAction = (typeof OCP_ANALYTICS.ACTION)[keyof typeof OCP_ANALYTICS.ACTION];

// Dimension ID mappings used by Matomo tracking.
// Keep visit-scoped and action-scoped IDs together here so they are easy to review.
// Visit-scoped custom dimension IDs (APPLICATION, MODE, HOST, WEBSITE)
export const VISIT_DIMENSION_IDS: Record<string, number> = {
  application: 1,
  mode: 2,
  host: 3,
  website: 4,
};

// Action-scoped custom dimension IDs (APPLICATION, MODE, HOST, WEBSITE)
export const ACTION_DIMENSION_IDS: Record<string, number> = {
  application: 5,
  mode: 6,
  host: 7,
  website: 8,
};

export const MATOMO_APP_NAME = 'OCP';

export const MATOMO_SESSION_KEYS = {
  SESSION_ID: 'session_id',
} as const;

export const MATOMO_ID_HEX_LEN = 32;

export const MATOMO_CONTEXT_CHANGED_EVENT = 'ocp-matomo-context-changed';
